import { render } from "./ChatUserList.vue?vue&type=template&id=e2d12144"
import script from "./ChatUserList.vue?vue&type=script&lang=js"
export * from "./ChatUserList.vue?vue&type=script&lang=js"
script.render = render

export default script